/**
 * Phone numbers as people type them, stored the way MP's own widget stored
 * them. Ten digits become "(248) 555-0134" while typing; anything else (an
 * extension, a country code, a partly typed number) is left exactly as typed
 * rather than mangled into a shape it is not.
 */

export function formatPhone(input: string): string {
  const digits = input.replace(/\D/g, '');
  if (input.trim().startsWith('+') || digits.length > 10) return input;
  if (digits.length < 4) return digits;
  if (digits.length < 7) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
}

/** Ten digits, or something deliberate enough to have a plus or an extension. */
export function isPhone(value: string): boolean {
  const digits = value.replace(/\D/g, '');
  return digits.length >= 10 && digits.length <= 15;
}
